import React, { useState } from "react";
import { Icon, Modal, notification } from "antd";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const GerarDocumento = ({ texto, ficheiroNome, ficheiroExportar, visibleExportar, btnDescarregar, onClose }) => {
    const [loadingDownload, setLoadingDownload] = useState(false);
    const extensao = ficheiroExportar ? ficheiroExportar.split(".").pop() : "";

    const handleDownload = async () => {
        if (!ficheiroExportar) return;

        try {
            setLoadingDownload(true);

            // 1. Ir buscar o ficheiro como um Blob (binário)
            const resposta = await fetch(ficheiroExportar);
            const blob = await resposta.blob();

            // 2. Criar um URL temporário para esse Blob no browser
            const urlBlob = window.URL.createObjectURL(blob);

            // 3. Criar o link de download "virtual"
            const link = document.createElement("a");
            link.href = urlBlob;

            // Se ficheiroNome estiver vazio, extrair da URL
            let nomeBase = ficheiroNome?.trim();

            if (!nomeBase) {
                // Extrair o nome do ficheiro da URL
                const url = new URL(ficheiroExportar);
                const pathname = url.pathname;
                const nomeDoFicheiro = pathname.substring(pathname.lastIndexOf("/") + 1);

                // Remover a extensão se já existir
                nomeBase = nomeDoFicheiro.replace(/\.[^/.]+$/, "") || "documento";
            }

            // Garante que o nome tem a extensão correta
            const nomeFinal = nomeBase.endsWith(`.${extensao}`) ? nomeBase : `${nomeBase}.${extensao}`;

            link.setAttribute("download", nomeFinal);
            document.body.appendChild(link);

            // 4. Disparar o clique e limpar
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(urlBlob); // Liberta memória

            onClose();
        } catch (error) {
            openNotificationWithIcon("error", "Erro no Download", "Ocorreu um erro ao descarregar o ficheiro.");
        } finally {
            setLoadingDownload(false);
        }
    };

    let informacao = (
        <>
            <Icon type="loading" />
            <p className="texto">{texto === "" ? "A gerar documento..." : texto}</p>
        </>
    );

    if (!btnDescarregar) {
        informacao = (
            <>
                <Icon type="check-circle" style={{ color: "#84bd00" }} />
                <p className="texto">Dados exportados com sucesso!</p>
                <p className="ficheiro-extensao">.{extensao}</p>
            </>
        );
    }

    return (
        <Modal
            visible={visibleExportar}
            okText="Descarregar"
            cancelText="Cancelar"
            onCancel={onClose}
            onOk={handleDownload}
            okButtonProps={{
                disabled: btnDescarregar || loadingDownload,
                loading: loadingDownload
            }}
            maskClosable={false}
            className="exportar-csv"
        >
            <div className="exportar-csv-bloco">{informacao}</div>
        </Modal>
    );
};

export default GerarDocumento;
